import { VIEWPORT_LAYOUT_DEBOUNCE_MS } from './density';

let resizing = false;
let timer: number | undefined;
let attached = false;
const idleListeners = new Set<() => void>();

function notifyIdle() {
  resizing = false;
  idleListeners.forEach((listener) => listener());
}

function handleResize() {
  resizing = true;
  if (timer) window.clearTimeout(timer);
  timer = window.setTimeout(notifyIdle, VIEWPORT_LAYOUT_DEBOUNCE_MS);
}

function ensureAttached() {
  if (attached || typeof window === 'undefined') return;
  attached = true;
  window.addEventListener('resize', handleResize, { passive: true });
}

export function isViewportResizing() {
  return resizing;
}

/** Run `fn` once the viewport has been idle. Used to skip layout work mid-drag. */
export function onViewportResizeIdle(fn: () => void) {
  ensureAttached();
  idleListeners.add(fn);
  return () => {
    idleListeners.delete(fn);
  };
}

export function resetViewportResizeForTests() {
  resizing = false;
  if (timer) window.clearTimeout(timer);
  timer = undefined;
  idleListeners.clear();
  if (attached && typeof window !== 'undefined') {
    window.removeEventListener('resize', handleResize);
    attached = false;
  }
}
